import { inject } from "@angular/core";
import { ResolveFn, Router } from "@angular/router";
import { UserService } from "../_services/user.service";
import { AuthService } from "../_services/auth.service";
import { FirebaseUserModel } from "../_models/user.model";

export const userResolver: ResolveFn<FirebaseUserModel> = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    return inject(UserService).getCurrentUser()
        .then(res => {
            authService.setAuthed(true);
            const user = new FirebaseUserModel();
            user.image = res.photoURL;
            user.name = res.displayName;
            user.provider = res.providerData[0].providerId;
            return user;
        })
        .catch(err => {
            router.navigate(["/login"]);
            throw err;
        });
};
